import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: any = {};

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<void> {
    try {
      this.config = await lastValueFrom(this.http.get('/assets/config.json'));
    } catch (error) {}
  }

  get(key: string) {
    return this.config[key];
  }
}
